module.exports = __webpack_public_path__ + "static/media/iconSayByeRobot.46352eda.svg";